import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { HubBrief } from '../models';
import { HubEndpoint } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class HubContextService {
  private readonly storageKey = 'selected-hub-context-id';

  constructor(private http: WrapperHttpService) {}

  getHubList(): Observable<HubBrief[]> {
    const url = `${API_URL}${HubEndpoint.Base}${HubEndpoint.Context}`;
    return this.http.withLoading().get<HubBrief[]>(url);
  }

  setHubContextIdToStorage(hubContext: HubBrief): void {
    const hubContextIdJson = JSON.stringify(hubContext.id);

    localStorage.setItem(this.storageKey, hubContextIdJson);
  }

  getHubContextIdFromStorage(): number {
    const hubContextIdJson = localStorage.getItem(this.storageKey);
    const hubContextId = JSON.parse(hubContextIdJson);

    return hubContextId;
  }
}
